import { alertModalTranslationJP } from 'components/common/AlertModal/translation/locales';
import { confirmModalTranslationJP } from 'components/common/ConfirmModal/translation/locales';
import { editModeHeaderTranslationJP } from 'components/common/EditModeHeader/translation/locales';
import { errorDataDetailModalTranslationJP } from 'components/common/ErrorDataDetailModal/translation/locales';
import { errorDataSummaryModalTranslationJP } from 'components/common/ErrorDataSummaryModal/translation/locales';
import { imageUploadModalTranslationJP } from 'components/common/ImageUploadModal/translation/locales';
import { reArrangeMenuModalTranslationJP } from 'components/common/ReArrangeMenuModal/translation/locales';
import { statusHeaderTranslationJP } from 'components/common/StatusHeader/translation/locales';
import { videoUploadModalTranslationJP } from 'components/common/VideoUploadModal/translation/locales';
import { selectDepartmentModalTranslationJP } from 'components/SelectDepartmentModal/locales';
import { selectSingleRestaurantModalTranslationJP } from 'components/SelectSingleRestaurantModal/locales';
import { selectTargetMenuModalTranslationJP } from 'components/SelectTargetMenuModal/translation/locales';
import { TargetMenuModalTranslationJP } from 'components/TargetMenuModal/translation/locales';
import { authFeatureTranslationJP } from 'features/Auth/translation/locales';
import { BarListTranslationJP } from 'features/BarGuideInfo/translation/locales';
import { BarMenuTranslationJP } from 'features/BarGuideInfoMenu/translation/locales';
import { characterSettingFeatureTranslationJP } from 'features/CharacterSetting/translation/locales';
import { counterPatternFeatureTranslationJP } from 'features/CounterPattern/translation/locales';
import { courseOrderQuantityLimitTranslationJP } from 'features/CourseOrderLimit/translation/locales';
import { DailyMenuTranslationJP } from 'features/DailyMenu/translation/locales';
import { defaultPanelFeatureTranslationJP } from 'features/DefaultPanel/translation/locales';
import { deliveryFeatureTranslationJP } from 'features/Delivery/translation/locales';
import { DisplayControlGroupTranslationJP } from 'features/DisplayControlGroup/translation/locales';
import { eatingWayFeatureTranslationJP } from 'features/EatingWay/translation/locales';
import { GenreTranslationJP } from 'features/Genre/translation/locales';
import { importDataTranslationJP } from 'features/ImportData/translation/locales';
import { mainMenuFeatureTranslationJP } from 'features/MainMenu/translation/locales';
import { menuBookFeatureTranslationJP } from 'features/MenuBook/translation/locales';
import { menuDetailFeatureTranslationJP } from 'features/MenuDetail/translation/locales';
import { MenuListTranslationJP } from 'features/MenuList/translation/locales';
import { menuServingTimeTranslationJP } from 'features/MenuServingTime/translation/locales';
import { OverlayFunctionTranslationJP } from 'features/OverlayFunction/translation/locales';
import { saleTypeFeatureTranslationJP } from 'features/SaleType/translation/locales';
import { serviceMenuTranslationJP } from 'features/ServiceMenu/translations/locales';
import { shabuSukiyakiTranslationJP } from 'features/ShabuSukiyaki/translation/locales';
import { storeFeatureTranslationJP } from 'features/Store/translation/locales';
import { SubGenreTranslationJP } from 'features/SubGenre/translation/locales';
import { subMenuListFeatureTranslationJP } from 'features/SubMenuList/translation/locales';
import { SubTitleMenuTranslationJP } from 'features/SubTitleMenu/translation/locales';
import { videoFunctionFeatureTranslationJP } from 'features/VideoFunction/translation/locales';
import { wizardFeatureTranslationJP } from 'features/Wizard/translation/locales';

const commonTranslationJP = {
  App: {
    app_name: process.env.REACT_APP_APP_NAME,
    error: 'エラー',
    info: '情報',
    warning: '警告',
    confirm: '確認',
    loading: '読み込み中...',
    change: '変更',
    success: '成功',
    unexpected_error: '処理に失敗しました',
  },
  ...statusHeaderTranslationJP,
  ...confirmModalTranslationJP,
  ...alertModalTranslationJP,
  ...selectDepartmentModalTranslationJP,
  ...selectSingleRestaurantModalTranslationJP,
  ...imageUploadModalTranslationJP,
  ...videoUploadModalTranslationJP,
  ...errorDataSummaryModalTranslationJP,
  ...errorDataDetailModalTranslationJP,
  ...reArrangeMenuModalTranslationJP,
  ...selectTargetMenuModalTranslationJP,
  ...editModeHeaderTranslationJP,
};

export const translationJP = {
  ...commonTranslationJP,
  ...authFeatureTranslationJP,
  ...mainMenuFeatureTranslationJP,
  ...MenuListTranslationJP,
  ...deliveryFeatureTranslationJP,
  ...storeFeatureTranslationJP,
  ...subMenuListFeatureTranslationJP,
  ...saleTypeFeatureTranslationJP,
  ...GenreTranslationJP,
  ...menuBookFeatureTranslationJP,
  ...importDataTranslationJP,
  ...menuDetailFeatureTranslationJP,
  ...SubGenreTranslationJP,
  ...BarListTranslationJP,
  ...SubTitleMenuTranslationJP,
  ...eatingWayFeatureTranslationJP,
  ...BarMenuTranslationJP,
  ...counterPatternFeatureTranslationJP,
  ...DisplayControlGroupTranslationJP,
  ...OverlayFunctionTranslationJP,
  ...TargetMenuModalTranslationJP,
  ...DailyMenuTranslationJP,
  ...courseOrderQuantityLimitTranslationJP,
  ...videoFunctionFeatureTranslationJP,
  ...shabuSukiyakiTranslationJP,
  ...serviceMenuTranslationJP,
  ...menuServingTimeTranslationJP,
  ...defaultPanelFeatureTranslationJP,
  ...wizardFeatureTranslationJP,
  ...characterSettingFeatureTranslationJP,
};
